function noop() {
}
const createDefaultLogger = (title, loggingDisabled) => {
  if (loggingDisabled) {
    return {
      log: noop,
      info: noop,
      warn: noop,
      error: noop,
      success: noop
    };
  }
  const logStyles = {
    log: { bg: "#1565C0", text: "#FFFFFF" },
    warn: { bg: "#F9BA1B", text: "#453408" },
    error: { bg: "#D63B1F", text: "#FFFFFF" },
    success: { bg: "#47B882", text: "#143324" }
  };
  const createLogFn = (key) => (...args) => console.log(
    `%c ${title} `,
    `background: ${logStyles[key].bg}; color: ${logStyles[key].text}; padding: 4px; border-radius: 4px;`,
    ...args
  );
  return {
    log: createLogFn("log"),
    warn: createLogFn("warn"),
    error: createLogFn("error"),
    success: createLogFn("success")
  };
};
export {
  createDefaultLogger
};
//# sourceMappingURL=createDefaultLogger.js.map
